<template>
    <div>
        <!-- <md-button class="md-raised" @click="assumePaid">Lets say they paid</md-button> -->
        <!-- <md-button class="md-raised" click="assumeNotPaid">Lets say they did not paid</md-button> -->
        <!-- <stripe-checkout
            ref="checkoutRef"
            :pk="publishableKey"
            :items="items"
            :successUrl="successUrl"
            :cancelUrl="cancelUrl"
        ></stripe-checkout> -->

    </div>
</template>

<script>
import axios from 'axios'

export default {
    methods: {}, 
    mounted() {
        let recaptchaScript = document.createElement('script')
        recaptchaScript.setAttribute('src', 'https://js.stripe.com/v3')
        document.head.appendChild(recaptchaScript)
        var stripe = Stripe('pk_live_iCMPKMFwjaPqekUDO0co17yI000UXMHD24')
        var response = fetch('https://us-central1-svcamp-6d3c3.cloudfunctions.net/api/id').then(function(response) {
            console.log(response)
            return response.json();
        }).then(function(responseJson) {
            var sessionID = responseJson.session_id;
            console.log(sessionID)
            // Call stripe.redirectToCheckout() with the Session ID.
            stripe.redirectToCheckout({
                sessionId: sessionID
            })
        });
    }
}
</script>